var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0279 0.662423L9.62467 2.06539L13.9343 6.37426L15.3375 4.9713C15.7625 4.54947 16 3.97454 16 3.37461C16 2.77468 15.7625 2.19974 15.3375 1.77792L14.2218 0.662423C13.7999 0.237472 13.2249 0 12.6248 0C12.0248 0 11.4498 0.237472 11.0279 0.662423ZM8.56524 3.12464L1.8399 9.84573C1.50551 10.1801 1.26174 10.5988 1.13361 11.055L0.0273065 15.0483C-0.0445722 15.3076 0.0273064 15.5888 0.221066 15.7794C0.414826 15.97 0.692966 16.045 0.952354 15.9731L4.94631 14.8639C5.40258 14.7358 5.81823 14.4952 6.15575 14.1577L12.8748 7.43351L8.56524 3.12464Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtnIcon);
export default __webpack_public_path__ + "static/media/edit-btn-icon.3dfd432121286f0dbd9d03b69fc748b8.svg";
export { ForwardRef as ReactComponent };